import React from 'react';
import { connect } from 'react-redux';
import TableStartHeader from '../../../components/MatchTimelineTable/TableStartHeader';
import HalfAndFullTimeTable from '../../../components/MatchTimelineTable/HalfAndFullTimeTable';
import { getMatchTimeline } from '../../../selectors/matchTimeline';
import { getEvents } from '../../../selectors/events';
import {
  getEventType, getMarkets, getMatchTimelineEvents, getTimezone,
} from '../../../selectors/common';
import HalfGoalsTable from './HalfGoalsTable';

const mapToProps = (state) => ({
  matchTimeline: getMatchTimeline(state),
  events: getEvents(state),
  eventType: getEventType(state),
  getTimezone: getTimezone(state),
  matchTimelineEvents: getMatchTimelineEvents(state),
  markets: getMarkets(state),

});

class MatchTimelineDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  filterGoalsToAccountForGoldenGoal = (goals) => {
    const currentGoals = goals.map((goal) => ({ ...goal }));
    const updatedGoals = [];
    for (let i = 0; i < currentGoals.length; i += 1) {
      if (currentGoals[i]?.eventType === this.props.eventType.GOAL_HOME
        && currentGoals[i + 1]
        && currentGoals[i + 1]?.eventType === this.props.eventType.GOLDEN_GOAL) {
        i += 1;
        currentGoals[i].homeGoldenGoal = true;
        updatedGoals.push(currentGoals[i]);
      } else if (currentGoals[i]?.eventType === this.props.eventType.GOAL_AWAY
        && currentGoals[i + 1]
        && currentGoals[i + 1]?.eventType === this.props.eventType.GOLDEN_GOAL) {
        i += 1;
        currentGoals[i].awayGoldenGoal = true;
        updatedGoals.push(currentGoals[i]);
      } else {
        updatedGoals.push(currentGoals[i]);
      }
    }
    return updatedGoals;
  };

  getLatestEventTime = () => {
    let latestEventTime;
    const halfTime = this.props.matchTimeline.find((event) => event.eventType
      === this.props.eventType.HALF_TIME);
    if (halfTime) {
      latestEventTime = halfTime.dateTime;
    } else {
      latestEventTime = this.props.matchTimeline[this.props.matchTimeline.length - 1].dateTime;
    }
    return latestEventTime;
  };

  getSecondPeriodStartTime = () => this.props.matchTimeline.find((event) => event.eventType
    === this.props.eventType.SECOND_PERIOD_START).dateTime;

  render() {
    let start = false;
    if (this.props.matchTimeline.find((event) => event.eventType
      === this.props.eventType.FIRST_PERIOD_START)) {
      start = true;
    }

    if (start) {
      return (
        <>
          <div className="table-responsive m-t-30">
            <table className="match">
              <thead className="thead--green">
                <TableStartHeader
                  period={this.props.eventType.FIRST_PERIOD_START}
                />
              </thead>
              <tbody>
                <HalfGoalsTable
                  isFirstHalfGoals
                  eventType={this.props.eventType}
                  matchTimeline={this.props.matchTimeline}
                  getTimezone={this.props.getTimezone}
                  markets={this.props.markets}
                  getLatestEventTime={this.getLatestEventTime}
                  filterGoalsToAccountForGoldenGoal={this.filterGoalsToAccountForGoldenGoal}
                />
              </tbody>
            </table>
          </div>

          {this.props.matchTimeline.find((event) => event.eventType
            === this.props.eventType.HALF_TIME)
            && (
              <HalfAndFullTimeTable
                matchTimeline={this.props.matchTimeline}
                eventType={this.props.eventType.HALF_TIME}
                getTimezone={this.props.getTimezone}
                matchTimelineEvents={this.props.matchTimelineEvents}
                tableColor="red"
              />
            )}

          {this.props.matchTimeline.find((event) => event.eventType
            === this.props.eventType.SECOND_PERIOD_START)
            && (
              <div className="table-responsive m-t-30">
                <table className="match">
                  <thead className="thead--green">
                    <TableStartHeader
                      period={this.props.eventType.SECOND_PERIOD_START}
                    />
                  </thead>
                  <tbody>
                    <HalfGoalsTable
                      eventType={this.props.eventType}
                      matchTimeline={this.props.matchTimeline}
                      getTimezone={this.props.getTimezone}
                      markets={this.props.markets}
                      getSecondPeriodStartTime={this.getSecondPeriodStartTime}
                      filterGoalsToAccountForGoldenGoal={this.filterGoalsToAccountForGoldenGoal}
                    />
                  </tbody>
                </table>
              </div>
            )}

          {this.props.matchTimeline.find((event) => event.eventType
            === this.props.eventType.MATCH_END)
            && (
              <HalfAndFullTimeTable
                matchTimeline={this.props.matchTimeline}
                eventType={this.props.eventType.MATCH_END}
                getTimezone={this.props.getTimezone}
                matchTimelineEvents={this.props.matchTimelineEvents}
                tableColor="black"
              />
            )}
        </>
      );
    }
    return null;
  }
}

export default connect(mapToProps)(MatchTimelineDetails);
